var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link } from '../../link';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { breadcrumbsItemClasses, BreadcrumbsItemComponentName, getBreadcrumbsItemUtilityClass, } from './breadcrumbs-item-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(Link, { name: BreadcrumbsItemComponentName, slot: 'Root' })(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            cursor: 'pointer',
            // easier react-router-dom integration
            '&.active': {
                color: theme.tokens.color_fg_bold,
            }
        },
        _b["& .".concat(breadcrumbsItemClasses.icon)] = {
            display: 'flex',
            fontSize: '1rem',
            '& > svg': {
                height: '1em',
                width: '1em',
            },
        },
        _b);
});
var StartIcon = styled('span', {
    name: BreadcrumbsItemComponentName,
    slot: 'StartIcon',
})(function (_a) {
    var theme = _a.theme;
    return ({
        marginRight: theme.spacing(1),
    });
});
var EndIcon = styled('span', {
    name: BreadcrumbsItemComponentName,
    slot: 'EndIcon',
})(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: theme.spacing(1),
    });
});
export var BreadcrumbsItem = React.forwardRef(function (props, ref) {
    var label = props.label, startIcon = props.startIcon, endIcon = props.endIcon, className = props.className, isCurrent = props.isCurrent, children = props.children, propClasses = props.classes, rootProps = __rest(props, ["label", "startIcon", "endIcon", "className", "isCurrent", "children", "classes"]);
    var classes = useMergedClasses(breadcrumbsItemClasses, getBreadcrumbsItemUtilityClass, propClasses);
    return (React.createElement(Root, __assign({ variant: "subtitle2", color: isCurrent ? 'textPrimary' : 'textSecondary', className: clsx(classes.root, isCurrent && classes.current, className), "aria-current": isCurrent ? 'page' : undefined, ref: ref }, rootProps),
        !!startIcon && React.createElement(StartIcon, { className: clsx(classes.icon, classes.startIcon) }, startIcon),
        React.createElement("span", { className: classes.label }, label || children),
        !!endIcon && React.createElement(EndIcon, { className: clsx(classes.icon, classes.endIcon) }, endIcon)));
});
